import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { Gutter, Suspense, TabsItem, Tabs, useApi } from '@axiom/ui';
import type {
  EnvoyCandidateSearchFilters,
  UserCandidateSearch,
} from '@axiom/validation';

import { TaxonomyApi } from '../../api/taxonomy-api';
import { UserSearchesApi } from '../../api/user-searches-api';
import { useAiSearch } from '../../providers/AiSearchContextProvider';
import { SavedSearches } from '../SavedSearches/SavedSearches';

import { CandidateFiltersForm } from './CandidateFiltersForm';

export const CandidateFilters = ({
  filters,
  onFilterChange,
  showSavedSearchTab,
}: {
  filters: EnvoyCandidateSearchFilters;
  onFilterChange: (updatedFilters: EnvoyCandidateSearchFilters) => void;
  showSavedSearchTab: boolean;
}) => {
  const { cancelSearch } = useAiSearch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [{ data: savedSearches }] = useApi(
    UserSearchesApi.readUserSearches('candidate')
  );

  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  useEffect(() => {
    const fetchUserSearch = async () => {
      const savedSearchId = searchParams.get('savedSearchId');
      if (savedSearchId) {
        const { data } =
          await UserSearchesApi.readUserSearch(savedSearchId).toPromise();

        cancelSearch();
        onFilterChange((data as UserCandidateSearch).search);
      }
    };
    void fetchUserSearch();
  }, []);

  return (
    <Gutter top="16px">
      <Tabs
        name="CANDIDATE_FILTERS_TABS"
        fluid
        startTab={showSavedSearchTab ? 'Saved' : 'Search'}
      >
        <TabsItem
          label="Search"
          name="Search"
          onClick={() => {
            searchParams.delete('showSavedSearches');
            setSearchParams(searchParams);
          }}
        >
          <Suspense>
            <CandidateFiltersForm
              taxonomy={taxonomy}
              filters={filters}
              isEditable
              handleFilterChange={filterChanges => {
                cancelSearch();
                onFilterChange(filterChanges);
              }}
            />
          </Suspense>
        </TabsItem>
        <TabsItem label="Saved" name="Saved" countBadge={savedSearches.length}>
          <SavedSearches
            onRunSearch={savedFilters => {
              cancelSearch();
              onFilterChange(savedFilters as EnvoyCandidateSearchFilters);
            }}
            savedSearches={savedSearches}
            type="candidate"
          />
        </TabsItem>
      </Tabs>
    </Gutter>
  );
};
